<template>
  <div class="licensesform">
    <div class="form-wrap">
      <div class="row-centered-items number-of-licenses">
        <div>
          <label class="text-septenary pl-3">{{ labels.qtdLicenses }}</label>
          <br />
          <p
            class="text-red02 text-small pl-3"
            v-if="licenses < activatedUsersCount"
          >
            {{ labels.msgLicensesLessThenUsers01 }}
            <b>{{ activatedUsersCount }}</b>
            {{ labels.msgLicensesLessThenUsers02 }}
            <br />
            <b-link
              class="text-primary text-bold"
              @click="$router.push({ name: 'dashboard.users.edit' })"
            >
              {{ labels.editUsers }}
            </b-link>
          </p>
        </div>
        <input class="form-control licenses" type="number" v-model="licenses" />
      </div>

      <div class="row-centered-items align-baseline pl-3 pr-3">
        <span>
          <b class="text-septenary">{{ labels.labelPricePerUser }}</b>
          <br />
        </span>

        <span class="text-gray03 price-per-user">
          x R$ {{ enterpriseMonthlyPrice | toCurrency }}
        </span>

        <small class="text-gray03 price-per-user-ps">
          {{ labels.notificationLimitLicenses }}
        </small>
      </div>

      <hr class="pl-3 pr-3" />

      <div class="row-centered-items total-price pl-3 pr-3">
        <small
          ><b>{{ labels.totalMonth }}</b></small
        >
        <span class="total">R$ {{ enterpriseMonthlyTotal | toCurrency }}</span>
      </div>

      <div class="text-center">
        <b-button
          variant="red02"
          class="bold pl-5 pr-5"
          @click="chosen(periods.MONTHLY)"
          :disabled="licenses < activatedUsersCount"
        >
          {{ labels.continue }}
        </b-button>
      </div>
    </div>
    <AnnuityBar
      @chosenAnnuity="chosen(periods.ANNUITY)"
      :licenses="parseInt(licenses)"
      :annuityPrice="enterpriseAnnuityPrice"
      :activatedUsersCount="activatedUsersCount"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { PERIODS, PLANS_TYPE } from '@/store/modules/account'
import AnnuityBar from '@/components/Shared/AnnuityBar.vue'

const props = {
  plans: {
    required: true,
    type: Array,
  },
  companyLicenses: {
    required: true,
    type: Object,
  },
}

export default {
  components: {
    AnnuityBar,
  },
  props,
  data() {
    return {
      licenses: 11,
    }
  },

  watch: {
    'companyLicenses.activatedUsersCount'(value) {
      this.licenses = value
    },
    licenses(value) {
      if (value < 0) this.licenses = 0
    },
  },

  computed: {
    ...mapGetters({
      resources: 'resources',
    }),

    labels: function() {
      return Object.assign(
        {},
        this.resources.page.home.accountGeneric,
        this.resources.page.home.licensesForm
      )
    },

    enterprisePrices: function() {
      const plan = this.plans.find(plan => plan.id === PLANS_TYPE.ENTERPRISE)
      return plan ? plan.prices : []
    },

    enterpriseAnnuityPrice: function() {
      const price = this.enterprisePrices.find(
        ({ period }) => period === this.periods.ANNUITY
      )
      return price ? price.pricePerUser : undefined
    },

    enterpriseMonthlyPrice: function() {
      const price = this.enterprisePrices.find(
        ({ period }) => period === this.periods.MONTHLY
      )
      return price ? price.pricePerUser : undefined
    },

    enterpriseMonthlyTotal: function() {
      return parseInt(this.licenses) * parseFloat(this.enterpriseMonthlyPrice)
    },

    periods: function() {
      return PERIODS
    },

    activatedUsersCount: function() {
      return this.companyLicenses.activatedUsersCount
    },
  },

  methods: {
    chosen: function(period) {
      this.$emit('chosen', { licenses: this.licenses, period })
    },
  },
}
</script>

<style lang="scss">
@import '~@/styles/custom/colors';

.licensesform {
  .form-wrap {
    padding: 3rem 6rem;

    @media (max-width: '1024px') {
      padding: 3rem;
    }

    @media (max-width: '425px') {
      padding: 1rem;
    }

    .pointer {
      cursor: pointer;
    }

    .b-form-group.form-group {
      margin-bottom: 0;
    }

    .text-small {
      font-size: 0.8rem;
    }

    .text-bold {
      font-weight: 500;
    }
  }
}
</style>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';
.licensesform {
  .row-column {
    display: flex;
    flex-direction: column;
  }

  .row-centered-items {
    align-items: baseline;
    color: map-get($theme-colors, 'septenary');
    display: flex;
    justify-content: space-between;
    margin-bottom: 3rem;

    @media (max-width: 425px) {
      margin-bottom: 2rem;

      &.number-of-licenses {
        flex-direction: column;
        align-items: baseline;
      }
    }

    label {
      font-size: 1.4rem;
      font-weight: 500;
    }

    .licenses {
      background: map-get($theme-colors, 'denary');
      border-radius: 55px !important;
      height: 55px !important;
      padding-right: 20px !important;
      text-align: right;
      width: 250px;

      @media (max-width: '425px') {
        width: 100%;
      }
    }

    &.total-price {
      font-size: 1.5rem;
      font-weight: 500;
      margin: 2rem 0;

      @media (max-width: '425px') {
        margin: 1.5rem 0;
      }
    }

    &.align-baseline {
      align-items: baseline;
      flex-wrap: wrap;

      .price-per-user {
        min-width: 70px;
      }

      .price-per-user-ps {
        width: 100%;
        flex-basis: 100%;
      }
    }
  }

  .btn.btn-red2 {
    border-radius: 55px !important;
    font-weight: 500;
    height: 55px !important;
    line-height: inherit;
    padding-left: 4rem;
    padding-right: 4rem;

    @media (max-width: '425px') {
      width: 100%;
    }
  }
}
</style>
